module.exports = __webpack_public_path__ + "img/alex.3788306b.jpeg";